export class UploadImageModel {
    id: number;
    complaintId: number;
}
